"use client";
import { Suspense, useEffect, type ReactNode } from "react";
import "./globals.css";
import Analytics from "@/components/Analytics";
import AdobePageLoadTracker from "@/components/AdobePageLoadTracker";
import { AppProviders } from "@/context/AppProviders";
import { usePathname } from "next/navigation";
import { initDatadogRum } from '../lib/observability/datadog';

interface RootLayoutProps {
  children: ReactNode;
}

let datadogRumInitialized = false;

export default function RootLayout({ children }: RootLayoutProps) {
  useEffect(() => {
    if (!datadogRumInitialized) {
      initDatadogRum();
      datadogRumInitialized = true;
    }
  }, []);

  const pathname = usePathname();

  const restrictedPaths = [
    "/producer",
    "/show",
    "/admin",
    "/showcompact",
    "/broadcast",
    "/broadcasttimed",
  ];

  const shouldLoadAnalytics = !restrictedPaths.includes(pathname);

  return (
    <html lang="en">
      <head>
        {/* {SEO_HYDRATE_KEY_VALUE} */}
      </head>
      <body>
        <AppProviders><Suspense>{children}</Suspense></AppProviders>

        {shouldLoadAnalytics && (
          <>
            <Analytics />
            <AdobePageLoadTracker />
          </>
        )}
      </body>
    </html>
  );
}
